import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface InspirationModel extends BaseModel {
  variables?: { [key: string]: string } | InspirationVariables;
}

export interface InspirationVariables {
  Inspiration1Image: string;
  Inspiration2Image: string;
  Inspiration1ImageHref: string;
  Inspiration2ImageHref: string;
  Inspiration1ImageAlt: string;
  Inspiration2ImageAlt: string;
  Inspiration1Heading: string;
  Inspiration2Heading: string;
  Inspiration1CtaLink: string;
  Inspiration2CtaLink: string;
  Inspiration1CtaText: string;
  Inspiration2CtaText: string;
  Inspiration1ImageHrefSegmentRegex: string;
  Inspiration2ImageHrefSegmentRegex: string;
  Inspiration1CtaLinkSegmentRegex: string;
  Inspiration2CtaLinkSegmentRegex: string;
}

export class InspirationInitVariables implements InspirationVariables {
  Inspiration1Image = '';
  Inspiration2Image = '';
  Inspiration1ImageHref = '';
  Inspiration2ImageHref = '';
  Inspiration1ImageAlt = '';
  Inspiration2ImageAlt = '';
  Inspiration1Heading = '';
  Inspiration2Heading = '';
  Inspiration1CtaLink = '';
  Inspiration2CtaLink = '';
  Inspiration1CtaText = '';
  Inspiration2CtaText = '';
  Inspiration1ImageHrefSegmentRegex = '';
  Inspiration2ImageHrefSegmentRegex = '';
  Inspiration1CtaLinkSegmentRegex = '';
  Inspiration2CtaLinkSegmentRegex = '';
}

export class InspirationInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new InspirationInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
